import { render } from "./ProfileAddress.vue?vue&type=template&id=b8a546a6&ts=true"
import script from "./ProfileAddress.vue?vue&type=script&lang=ts"
export * from "./ProfileAddress.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__